import gql from 'graphql-tag';
import {
	SHOP_MENU_UPDATE_START,
	SHOP_MENU_UPDATE_SUCCESS,
	SHOP_MENU_UPDATE_ERROR
} from '../../../constants/index';
import { toastr } from 'react-redux-toastr';
import { loadAccount } from '../userAccount/userAccount';

const query = gql`
query($currentPage: Int, $searchList: String, $menuId: Int) {
	getAllSubMenu(currentPage: $currentPage, searchList: $searchList, menuId: $menuId){
	  status
	  errorMessage
	  menuName
	  results {
		id
		shopId
		menuId
		name
		isEnable
		item {
			id
			subMenuId
			menuId
			itemName
			itemDescription
			price
			tax
			image
			itemType
			isEnable
		}
	  }
	}  
  }
`;


export default function deleteItem(id, currentPage, menuId) {
	return async (dispatch, getState, { client }) => {
		dispatch({
			type: SHOP_MENU_UPDATE_START,
			payload: {
				updateLoading: true
			}
		});

		try {
			let errorMessage;

			const mutation = gql`
            mutation deleteItem($id: Int) {
							deleteItem(id: $id) {
								status
								errorMessage
							}
						}
            `;

			const { data } = await client.mutate({
				mutation,
				variables: {
					id
				},
				refetchQueries: [{ query, variables: { currentPage, searchList: '', menuId } }]
			});

			if (data && data.deleteItem && data.deleteItem.status === 200) {
				dispatch({
					type: SHOP_MENU_UPDATE_SUCCESS,
					payload: {
						updateLoading: false
					}
				});
				toastr.success('Success', `The Item has been deleted successfully.`);
				dispatch(loadAccount())
			} else {
				dispatch({
					type: SHOP_MENU_UPDATE_ERROR,
					payload: {
						updateLoading: false
					}
				});

				errorMessage = (data && data.deleteItem && data.deleteItem.errorMessage) || "Oops! Something went wrong. Please try again.";
				toastr.error('Error!', errorMessage);
			}
		} catch (err) {
			toastr.error('Error!', err);
			dispatch({
				type: SHOP_MENU_UPDATE_ERROR,
				payload: {
					updateLoading: false
				}
			});
		}
	}
};
